import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getWorkflow } from 'modules/workflows/ducks';
import { PublishedWorkflowsMultiSelect } from 'modules/workflowNodeEditors/components/TriggerWorkflowEditor/WorkflowSelect';
import { StyledRadioList, StyledFormField } from './EntranceLimitForm.styled';
import {
  ConcurrentJourneyEntranceCriteriaType,
  concurrentJourneyEntranceCriteriaTypeOptions,
  startEditorText,
} from './EntranceLimitForm.constants';

export const getInitialTypeValue = (journeys: number[] | undefined = undefined) => {
  if (journeys === undefined || journeys === null)
    return ConcurrentJourneyEntranceCriteriaType.canEnter;
  if (journeys.length === 0) return ConcurrentJourneyEntranceCriteriaType.cannotEnter;
  return ConcurrentJourneyEntranceCriteriaType.maybeCanEnter;
};

type ConcurrentJourneyEntranceCriteriaProps = {
  onConcurrentJourneyEntranceCriteriaUpdate: (journeys: number[] | undefined) => void;
  journeys?: number[];
  error?: string;
  isReadOnly?: boolean;
};

export const ConcurrentJourneyEntranceCriteria = (
  props: ConcurrentJourneyEntranceCriteriaProps,
) => {
  const workflow = useSelector(getWorkflow);
  let initialTypeValue = getInitialTypeValue(props.journeys);
  const [typeValue, setTypeValue] = useState(initialTypeValue);
  const handleTypeUpdate = (
    type: ConcurrentJourneyEntranceCriteriaType,
    journeys: number[] | undefined = undefined,
  ) => {
    setTypeValue(type);
    if (type === ConcurrentJourneyEntranceCriteriaType.canEnter)
      props.onConcurrentJourneyEntranceCriteriaUpdate(undefined);
    if (type === ConcurrentJourneyEntranceCriteriaType.cannotEnter)
      props.onConcurrentJourneyEntranceCriteriaUpdate([]);
    if (type === ConcurrentJourneyEntranceCriteriaType.maybeCanEnter)
      props.onConcurrentJourneyEntranceCriteriaUpdate(journeys);
  };

  return (
    <StyledFormField
      labelText={startEditorText.multipleJourneysHeading}
      descriptionText={startEditorText.multipleJourneysDescription}
      hasError={!!props.error}
      errorText={props.error}
    >
      <StyledRadioList
        onSelect={handleTypeUpdate}
        options={concurrentJourneyEntranceCriteriaTypeOptions.map((opt) => ({
          ...opt,
          isDisabled: props.isReadOnly,
        }))}
        value={typeValue}
        name="concurrent-journey-entrance-criteria"
      />
      <PublishedWorkflowsMultiSelect
        journeys={props.journeys}
        isReadOnly={
          props.isReadOnly || typeValue !== ConcurrentJourneyEntranceCriteriaType.maybeCanEnter
        }
        onlyPublished
        workflow={workflow}
        onChange={(value) => {
          if (typeValue === ConcurrentJourneyEntranceCriteriaType.maybeCanEnter) {
            handleTypeUpdate(
              ConcurrentJourneyEntranceCriteriaType.maybeCanEnter,
              /*value?.map((j) => j.id)*/ value, //we can either get the []PublishedJourney and then map or just get the ids directyl
            );
          }
        }}
      />
    </StyledFormField>
  );
};
